/**
 * Append the incoming query string to a redirect target.
 *
 * Ads click IDs (gclid, gbraid, wbraid) and UTM tags arrive in the query
 * string. A 301 that drops it loses the click: the landing page stores
 * nothing, and the lead reaches Salesforce with no source. Measured 29 Sep
 * 2026: 9,879 ad clicks from 15 to 21 Sep landed on redirects that did this.
 */
export function withQuery(href: string, searchStr: string): string {
  if (!searchStr || searchStr === "?") return href;
  const qs = searchStr.startsWith("?") ? searchStr.slice(1) : searchStr;
  return href + (href.includes("?") ? "&" : "?") + qs;
}
